import authreducer from './auth_reducer';
import userreducer from './user_reducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    auth: authreducer,
    user: userreducer
})
export default rootReducer;